import { render, staticRenderFns } from "./SectorsEdit.vue?vue&type=template&id=77a8fb1a&scoped=true&"
import script from "./SectorsEdit.vue?vue&type=script&lang=js&"
export * from "./SectorsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a8fb1a",
  null
  
)

export default component.exports